module.exports = __webpack_public_path__ + "static/img/AD.ed6ff6cc.svg";